var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 33.992,
    viewBox: "0 0 34 33.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M17,10.519a8.715,8.715,0,1,0,8.715,8.715A8.7,8.7,0,0,0,17,10.519ZM17,24.9a5.666,5.666,0,1,1,5.666-5.666A5.676,5.676,0,0,1,17,24.9ZM28.1,10.162A2.033,2.033,0,1,1,26.07,8.129,2.028,2.028,0,0,1,28.1,10.162Zm5.772,2.063A10.06,10.06,0,0,0,31.129,5.1c-1.987-1.987-4.4-2.609-7.122-2.746C21.2,2.2,12.789,2.2,9.982,2.357A10.111,10.111,0,0,0,2.86,5.1C.865,7.083.251,9.495.114,12.218c-.159,2.806-.159,11.218,0,14.025A10.06,10.06,0,0,0,2.86,33.365a10.139,10.139,0,0,0,7.122,2.746c2.806.159,11.218.159,14.025,0a10.06,10.06,0,0,0,7.122-2.746c1.987-1.987,2.609-4.4,2.746-7.122.159-2.806.159-11.211,0-14.017ZM30.25,29.254a5.736,5.736,0,0,1-3.231,3.231c-2.238.887-7.547.683-10.02.683s-7.79.2-10.02-.683a5.736,5.736,0,0,1-3.231-3.231c-.887-2.238-.683-7.547-.683-10.02s-.2-7.79.683-10.02A5.736,5.736,0,0,1,6.979,5.983C9.216,5.1,14.526,5.3,17,5.3s7.79-.2,10.02.683A5.736,5.736,0,0,1,30.25,9.214c.887,2.238.683,7.547.683,10.02S31.137,27.024,30.25,29.254Z",
    transform: "translate(0.005 -2.238)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramlogo);
export default __webpack_public_path__ + "static/media/instagramlogo.2184056b672bfffd65c2e121ce327893.svg";
export { ForwardRef as ReactComponent };